var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "modal-body" }, [
      _c(
        "form",
        { staticClass: "m-form m-form--state", attrs: { action: "" } },
        [
          _c("div", { staticClass: "m-portlet__body" }, [
            _c(
              "div",
              {
                staticClass: "form-group m-form__group row",
                class: { "has-danger": _vm.errors.has("name") }
              },
              [
                _c(
                  "div",
                  {
                    class: _vm.validPermission("create", "phrase")
                      ? "col-lg-11"
                      : "col-lg-12"
                  },
                  [
                    _c("label", { attrs: { for: "name" } }, [_vm._v("Name")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.config.name,
                            expression: "config.name"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass:
                          "form-control m-bootstrap-select m_selectpicker",
                        attrs: {
                          id: "name",
                          name: "name",
                          "data-live-search": "true",
                          title: _vm._f("capitalize")(
                            _vm._f("translate")("select_an_option")
                          )
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.config,
                              "name",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(_vm.names, function(phrase) {
                        return _c(
                          "option",
                          { key: phrase.key, domProps: { value: phrase.key } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")(phrase.value)
                                )
                              )
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.validPermission("create", "phrase")
                  ? _c("div", { staticClass: "col-lg-1" }, [
                      _c("label", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn btn-outline-success m-btn m-btn--icon m-btn--icon-only m-btn--outline-2x",
                          attrs: {
                            "data-toggle": "modal",
                            "data-backdrop": "static",
                            "data-keyboard": "false",
                            "data-target": "#phrases_modal",
                            href: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeModalPhraseStatus(true)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa flaticon-add" })]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("name"),
                        expression: "errors.has('name')"
                      }
                    ],
                    staticClass: "m-form__help m--font-danger"
                  },
                  [_vm._v(" " + _vm._s(_vm.errors.first("name")) + " ")]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c(
                "div",
                {
                  staticClass: "col-lg-12",
                  class: { "has-danger": _vm.errors.has("permission") }
                },
                [
                  _c("label", { attrs: { for: "permission" } }, [
                    _vm._v("Permission")
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.config.permission_id,
                          expression: "config.permission_id"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      class: {
                        "form-control": true,
                        error: _vm.errors.has("permission")
                      },
                      attrs: { id: "permission", name: "permission" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.config,
                            "permission_id",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v(
                          "\n                Select an option\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.permissions, function(p) {
                        return _c(
                          "option",
                          { key: p.id, domProps: { value: p.id } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(p.name) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("permission"),
                          expression: "errors.has('permission')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("permission")) + " ")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c(
                "div",
                {
                  staticClass: "col-lg-12",
                  class: { "has-danger": _vm.errors.has("type") }
                },
                [
                  _c("label", { attrs: { for: "type" } }, [_vm._v("Type")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.config.type_id,
                          expression: "config.type_id"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      class: {
                        "form-control": true,
                        error: _vm.errors.has("type")
                      },
                      attrs: { id: "type", name: "type" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.config,
                              "type_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          _vm.showComponent
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v(
                          "\n                Select an option\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.types, function(t) {
                        return _c(
                          "option",
                          { key: t.id, domProps: { value: t.id } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(t.name) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("type"),
                          expression: "errors.has('type')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("type")) + " ")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm.display_component
              ? _c(
                  "div",
                  _vm._l(_vm.config.option, function(v, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "form-group m-form__group row"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "col-lg-6",
                            class: {
                              "has-danger": _vm.errors.has("key_" + index)
                            }
                          },
                          [
                            _c("label", { attrs: { for: "key_" + index } }, [
                              _vm._v("Key")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: v.key,
                                  expression: "v.key"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|min:2|max:70",
                                  expression: "'required|min:2|max:70'"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: {
                                id: "key_" + index,
                                type: "text",
                                name: "key_" + index,
                                placeholder: "Insert a key"
                              },
                              domProps: { value: v.key },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(v, "key", $event.target.value)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("key_" + index),
                                    expression: "errors.has(`key_${index}`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.errors.first("key_" + index)) +
                                    " "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-lg-6",
                            class: {
                              "has-danger": _vm.errors.has("value_" + index)
                            }
                          },
                          [
                            _c("label", { attrs: { for: "value_" + index } }, [
                              _vm._v("Value")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: v.name,
                                    expression: "v.name"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|min:2|max:70",
                                    expression: "'required|min:2|max:70'"
                                  }
                                ],
                                staticClass: "form-control m-input",
                                attrs: {
                                  id: "value_" + index,
                                  type: "text",
                                  name: "value_" + index,
                                  placeholder: "Insert a value"
                                },
                                domProps: { value: v.name },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(v, "name", $event.target.value)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.config.option.length - 1 > 0
                                ? _c("div", { staticClass: "col-lg-2" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-outline-danger m-btn m-btn--icon m-btn--icon-only m-btn--outline-2x",
                                        attrs: { href: "" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.deleObject(index)
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "la la-trash" })]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              index == _vm.config.option.length - 1
                                ? _c("div", { staticClass: "col-lg-2" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-outline-success m-btn m-btn--icon m-btn--icon-only m-btn--outline-2x",
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.addNew()
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "la la-plus-circle"
                                        })
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("value_" + index),
                                    expression: "errors.has(`value_${index}`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.errors.first("value_" + index)) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c(
                "div",
                {
                  staticClass: "col-lg-12",
                  class: { "has-danger": _vm.errors.has("validation") }
                },
                [
                  _c("label", { attrs: { for: "validation" } }, [
                    _vm._v("Validation")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.config.validation,
                        expression: "config.validation"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "min:5",
                        expression: "'min:5'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      id: "validation",
                      type: "text",
                      placeholder: "Insert a validation",
                      name: "validation"
                    },
                    domProps: { value: _vm.config.validation },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.config, "validation", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("validation"),
                          expression: "errors.has('validation')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("validation")) + " ")]
                  )
                ]
              )
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", "data-dismiss": "modal", id: "btn-cancel" },
          on: { click: _vm.resetForm }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("cancel"))) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "button" },
          on: { click: _vm.submitForm }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("submit"))) +
              "\n    "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-197dc6bb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-197dc6bb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/config/New.vue
// module id = 449
// module chunks = 0 1 60 190